import { useCallback } from 'react'

export const useCellTitle = (title?: string) =>
  useCallback(
    (e: React.SyntheticEvent<Element>) => {
      const element = e.target as HTMLDivElement
      if (element && title) {
        if (element.scrollWidth > element.offsetWidth) {
          element.setAttribute('title', title)
        } else {
          element.removeAttribute('title')
        }
      }
    },
    [title]
  )
